var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.623 0.728394C5.36288 0.728394 1.72473 3.44909 0.250732 7.28955C1.72473 11.13 5.36288 13.8507 9.623 13.8507C13.8831 13.8507 17.5213 11.13 18.9953 7.28955C17.5213 3.44909 13.8831 0.728394 9.623 0.728394ZM9.623 11.6637C7.27141 11.6637 5.36288 9.70406 5.36288 7.28955C5.36288 4.87504 7.27141 2.91545 9.623 2.91545C11.9746 2.91545 13.8831 4.87504 13.8831 7.28955C13.8831 9.70406 11.9746 11.6637 9.623 11.6637ZM9.623 4.66509C8.20864 4.66509 7.06693 5.83735 7.06693 7.28955C7.06693 8.74175 8.20864 9.91401 9.623 9.91401C11.0374 9.91401 12.1791 8.74175 12.1791 7.28955C12.1791 5.83735 11.0374 4.66509 9.623 4.66509Z",
    fill: "#DFDFE7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/show.b2d8cc104042500d24bd7bb51e7dae93.svg";
export { ForwardRef as ReactComponent };